import React from 'react';
import I18n from 'i18n-js';
import { times } from 'lodash';
import FormGroupWithSelect from '../components/form_group_with_select';
import { core_apimessages_NegotiationParty } from '../rql';
import bind from '../bind';

interface IProps {
  inventory: number;
  party: core_apimessages_NegotiationParty;
  quantity: number;
  onQuantityChange: (offer: { quantity: number }) => void;
}

function inventoryOption(offset: number) {
  const displayQuantity = `${offset + 1}`;
  return { text: displayQuantity, value: displayQuantity };
}
class OfferQuantitySelect extends React.Component<IProps> {

  @bind
  onSelect(inputOffer: { quantity: string }) {
    this.props.onQuantityChange({
      quantity: parseInt(inputOffer.quantity, 10),
    });
  }

  render() {
    const inventoryOptions = times(this.props.inventory, inventoryOption);
    return (
      <FormGroupWithSelect
        label={I18n.t('commons.offers.offerQuantity')}
        inputName="offer-quantity"
        fieldName="quantity"
        options={inventoryOptions}
        value={`${this.props.quantity}`}
        updateField={this.onSelect}
        disabled={this.props.party === core_apimessages_NegotiationParty.BUYER}
      />
    );
  }
}

export default OfferQuantitySelect;
